<template>
  <div>
    <mp-simple-spinner v-if="loading" />
    <div v-show="!loading" v-else ref="player" class="player" />
  </div>
</template>

<script>
import { RecordingManager } from "@/Packages/Recordings/Manager/RecordingManager";

export default {
  name: "VideoPlayer",
  props: {
    recordingId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      loading: false,
      player: null,
      attributes: {
        url: null,
        mime: null,
        startDateTime: null,
        poster: null
      }
    };
  },
  created() {
    this.loading = true;
    let manager = new RecordingManager();
    manager
      .getRecordingForPlayer(this.recordingId)
      .then(apiResponse => {
        let data = apiResponse.getSingleData();
        this.attributes.url = data.get("playlistUrl");
        this.attributes.mime = data.get("mimeType");
        this.attributes.startDateTime = data.getDate("startTime");
        this.attributes.poster = data.get("poster");
        this.attributes.poster =
          "https://savagebull.com.au/themes/savagebull/images/bull.png";
      })
      .catch(() => {})
      .finally(() => {
        this.loading = false;
        this.bindPlayer();
      });
  },
  beforeDestroy() {
    this.player.destroy();
  },
  methods: {
    bindPlayer() {
      this.$nextTick(() => {
        let player = new MMMediaPlayer(this.$refs.player, {
          clippingEnabled: true,
          clippingInternal: true
        });
        console.log(this.attributes.startDateTime);
        player.setSrc(
          this.attributes.url,
          this.attributes.mime,
          this.attributes.startDateTime,
          this.attributes.poster
        );
        player.play();
        player.on("clip", (startTime, duration) => {
          this.createClip(startTime, duration);
        });
        this.player = player;
      });
    },
    createClip(startTime, duration) {
      let manager = new RecordingManager();
      manager
        .createClip(this.recordingId, startTime, duration)
        .then(apiResponse => {
          this.$mp.toast.success("Clip is now processing.");
        })
        .catch(apiResponse => {
          console.log("failure");
        });
    }
  }
};
</script>

<style scoped></style>
